// extracted by mini-css-extract-plugin
module.exports = {"CMSPosts":"CMSPosts___2Is3P","SectionTitle":"SectionTitle___3rJZ5","CMSPostItem":"CMSPostItem___26Ifn","PostTitle":"PostTitle___eJ22L","loading":"loading___3T2IA"};